import { render } from "./knowledgeLeft.vue?vue&type=template&id=56f3b02f&scoped=true"
import script from "./knowledgeLeft.vue?vue&type=script&lang=js"
export * from "./knowledgeLeft.vue?vue&type=script&lang=js"

import "./knowledgeLeft.vue?vue&type=style&index=0&id=56f3b02f&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f3b02f"]])

export default __exports__